import * as types from "./deca.actionTypes";
import * as commonActionType from "@common/store/common/common.actionsType";
import store from "@common/store/store";
import Immutable from "seamless-immutable";

const initialState = Immutable({
  ComboGrupo: [],
  Situacao: undefined,
  Tipo: undefined,
  parametro: undefined,
  registrarSolicitacao: {
    parametro: [],
  },
  typeDeca: 0,
  loadDeca: 1,
  somenteEnderecoSede: false,
  disableAllSolicitacao: false,
});

const reduce = (state = initialState, action = {}) => {
  let payload = action.payload === undefined ? {} : action.payload;
  switch (action.type) {
    case types.DECASOLICITACAO_SET:
      return state.merge(payload);
    case types.SET_REDUCER_TYPEDECA:
      return state.merge({ typeDeca: payload });
    case types.SET_REDUCER_LOADDECA:
      return state.merge({ loadDeca: payload });
    case types.DECASOLICITACAO_SETCOMBOGRUPO:
      return state.merge({ ComboGrupo: payload.data });
    case types.PARAMETRO_SET:
      return state.merge({
        registrarSolicitacao: {
          ...state.registrarSolicitacao,
          parametro: payload,
        },
      });
    case types.SET_SOMENTE_ENDERECO_SEDE:
      return state.merge({ somenteEnderecoSede: payload });
    case types.SET_DISABLE_ALL_SOLICITACAO:
      return state.merge({ disableAllSolicitacao: payload });
    default:
      return state;
  }
};

store.registerDynamicModule("deca", reduce);
